import {chain} from 'lodash';

import {ActionBase} from '../../../helpers/reduxHelpers';
import {MessageStatusesEnum, MessageVisualStatusesEnum} from '../../../models/api/messageModel';
import {ThunkAction} from '../../appThunk';
import {popoutComposerAction} from '../../panels/composer/composerPanelActions';

/*
 * Action types.
 */

export enum OfflineActionsEnum {
  CLEAR_OFFLINE_DRAFTS = '@@data/offline/CLEAR_OFFLINE_DRAFTS',
}

/*
 * Types.
 */

export interface ClearOfflineDraftsAction extends ActionBase {
  type: OfflineActionsEnum.CLEAR_OFFLINE_DRAFTS;
}

/*
 * Action creators.
 */

export function reopenOfflineDraftMessages(): ThunkAction {
  return (dispatch, getState) => {
    const {messages, offlineDraftMessageUids} = getState().data;

    // Re-open the drafts that were never successfully saved before.
    const draftsToOpenUids = chain(offlineDraftMessageUids)
      .map((uid) => messages[uid])
      .compact()
      .map((m) => m.visualStatus === MessageVisualStatusesEnum.DRAFT && m)
      .compact()
      .filter((m) => m.status === MessageStatusesEnum.DRAFT_COMPOSE && !m.conversationId)
      .map((m) => m.uid)
      .value();

    draftsToOpenUids.forEach((uid) => dispatch(popoutComposerAction(uid)));
  };
}

export function clearOfflineDrafts(): ClearOfflineDraftsAction {
  return {type: OfflineActionsEnum.CLEAR_OFFLINE_DRAFTS};
}

/*
 * Union type.
 */

export type OfflineAction = ClearOfflineDraftsAction;
